import consensusAnalysis from './consensusAnalysis';
import financialStatement from './financialStatement';
import financialAnalysis from './financialAnalysis';
import ownerShip from './ownerShip';
import snapShot from './snapShot';
import cashDividend from './cashDividend';
import commonFundamental from './common';

export default {
  financialStatement,
  financialAnalysis,
  ownerShip,
  snapShot,
  cashDividend,
  consensusAnalysis,
  commonFundamental,
};
